import Domiciliation from './Domiciliation'
import ForwardingAddresses from './ForwardingAddresses'
import PersonnalPostalProxy from './PersonnalPostalProxy'
import HotlineContacts from './HotlineContacts'

const tabs = [
  {
    name: 'general',
    display_name: 'Général',
    component: Domiciliation,
  },
  {
    name: 'postal-proxy',
    display_name: 'Pouvoir Courrier',
    component: PersonnalPostalProxy,
  },
  {
    name: 'forwarding-addresses',
    display_name: 'Adresses de réexpedition',
    component: ForwardingAddresses,
    display_condition: (state, getters) => {
      // mailOption is determined when ContractManagement is created
      // so we check for the appriopriate option flag
      
      // Old version
      // const mailOption = state.contract.contractMailOption
      // return mailOption && _.has(mailOption, 'id') && mailOption.option.mail_forwarded

      const contractModel = state.contract.model
      
      return _.filter(contractModel.contract_options, co => {
        return co.option.mail_forwarded && _.includes(['active', 'pending-termination'], co.status)
      }).length > 0
    }
  },
  {
    name: 'hotline-contacts',
    display_name: 'Contacts permanence téléphonique',
    component: HotlineContacts,
    display_condition: (state, getters) => {
      return true
      const contractModel = state.contract.model
      
      return _.filter(contractModel.contract_options, co => {
        return co.option.simple_hotline && _.includes(['active', 'pending-termination'], co.status)
      }).length > 0
    }
  }
]

export default tabs

export const moduleName = "contractManagement"



// WEBPACK FOOTER //
// ./client/components/Customer/ContractManagementContent/tabs.js